<template>
  <!-- orange border -->
  <div
    class="rounded-[9px] p-[6px]"
    style="background: linear-gradient(to bottom, #ffa800, #b55700)"
  >
    <!-- orange body -->
    <div
      class="flex flex-col bg-gradient-to-b from-[#FFE792] to-[#FFC369] justify-between rounded-[9px] h-full"
    >
      <div class="flex flex-row justify-between">
        <div
          class="flex flex-col font-bold text-transparent font-[400] mt-[12px] leading-none pl-[16px]"
          style="
            font-family: 'a Big Deal';
            filter: drop-shadow(-1px 1px 0px rgba(255, 255, 255, 0.81));
          "
        >
          <div class="text-[1rem] bg-gradient-to-b from-[#4F8100] to-[#304F00] bg-clip-text">
            {{ title }}
          </div>
          <div class="text-[1.25rem] bg-gradient-to-b from-[#4F8100] to-[#304F00] bg-clip-text">
            {{ subtitle }}
          </div>
        </div>
        <img
          src="/assets/absolutely/homepage/cancel.svg"
          alt="Cancel"
          class="mt-[8px] w-[34px] h-[34px] pr-[8px] mb-[8px] cursor-pointer"
          @click="handleClose"
        />
      </div>
      <div class="flex justify-end">
        <CtaButton
          :label="buttonLabel"
          :block="false"
          class="mr-[16px] mb-[15px]"
          @click="handleClick(selectedChapterId)"
        ></CtaButton>
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedButton from './AnimatedButton.vue';
import CtaButton from './CtaButton.vue';

export default {
  name: 'ChapterConfirmPopup',
  components: {
    AnimatedButton,
    CtaButton,
  },
  props: {
    buttonLabel: {
      type: String,
      default: 'EXPLORE',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    selectedChapterId: {
      type: Number,
    },
  },
  methods: {
    handleClick(chapterId) {
      // Emit close event first to trigger popup close animation
      this.$emit('close');
      // Navigate after a brief delay to allow close animation to complete
      setTimeout(() => {
        this.$router.push(`/absolutely/chapter/${chapterId}`);
      }, 250);
    },
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>
